<div class="modal-container modal-sm">
    <!-- Close -->
    <div class="modal-close-container">
        <bizz-icon class="text-on-button ml-auto block h-5 w-5 md:ml-0" (click)="dialogRef.close()" iconName="xmark"
            [hover]="true">
        </bizz-icon>
    </div>
    <div class="modal-body flex flex-col">
        <div class="modal-header">
            <h1>{{'SetAllGrades' | translate }}</h1>
        </div>
        <hr class="my-4" />

        <div class="mb-4 flex w-full flex-row items-center text-sm">
            <span class="w-[40%] font-bold">{{'NewGrade' | translate }}</span>
            <kendo-combobox id="ThemesID" class="w-[60%] text-sm"
                [valuePrimitive]="true" [formControl]="skillGradeId" [data]="data.SkillGrades" textField="Name" valueField="ID">
                <ng-template kendoComboBoxItemTemplate let-dataItem>
                <div>{{dataItem.Name}} ({{dataItem.Score}}%)</div>
                </ng-template>
            </kendo-combobox>

        </div>

        <span class="mb-2 text-sm font-bold">{{ 'Reason_Remark' | translate }}</span>
        <div class="w-full cursor-text" (click)="textArea.focus()">
            <kendo-textarea #textArea [classList]="'flex items-start h-full bg-form-control text-default'"
            [formControl]="skillGradeChangeReason" [rows]="2">
            </kendo-textarea>
        </div>
    </div>
    <div class="modal-buttons">
        <button class="save" (click)="save()">
            {{'SetAll' | translate}}
        </button>
    </div>
</div>